import { DATA } from '../../mocks/app-branding-config.data';
import { IAppBrandingConfig } from '../../interfaces';
import { IAppBrandingConfigService } from './app-branding-config.interface';
import { injectable } from 'inversify';

@injectable()
export class AppBrandingConfigMock implements IAppBrandingConfigService {

    get(): Promise<IAppBrandingConfig> {
        return Promise.resolve(DATA);
    }
}
